import DataProvider from '@/features/explanation/context'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/explanations')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <DataProvider >
            <Outlet />
        </DataProvider>
    )
}
